import { FilterList } from '@mui/icons-material'
import { Stack } from '@mui/material'
import { type FC } from 'react'
import {
    FiltersDrawer,
    type FilterTab,
} from 'recruiter/components/FiltersDrawer'
import { useRosterSqlSearch } from 'recruiter/hooks'
import { type RosterFilterState } from 'shared/hooks/rosterFilterState'
import { CompanyFilters } from './MinimalFilters'

const iconSx = { fontSize: '1.125rem' }

export const RosterFiltersDrawer: FC = () => {
    const { tableState, setTableState } = useRosterSqlSearch()
    const filters = tableState.filters
    const updateFilters = (patch: Partial<RosterFilterState>) =>
        setTableState({ filters: { ...filters, ...patch } })

    const hasCompanyFilters =
        filters.companyIds.length > 0 ||
        filters.titleIds.length > 0 ||
        !!filters.consultants ||
        filters.fundSizeIds.length > 0 ||
        filters.visaStatusIds.length > 0 ||
        filters.industryIds.length > 0 ||
        filters.sectorIds.length > 0 ||
        filters.geoLocationText.length > 0 ||
        filters.geoLocationIds.length > 0 ||
        filters.startDates.length > 0 ||
        filters.processStatusIds.length > 0 ||
        filters.processStatusGroupIds.length > 0 ||
        !!filters.type ||
        filters.internalUserIds.length > 0 ||
        filters.createdByUserIds.length > 0 ||
        !!filters.createdAtGte ||
        !!filters.createdAtLte
    const tabs: FilterTab[] = [
        {
            icon: <FilterList sx={iconSx} />,
            label: 'Filters',
            content: (
                <Stack gap={1.5} sx={{ p: 2 }}>
                    <CompanyFilters
                        filters={filters}
                        updateFilters={updateFilters}
                    />
                </Stack>
            ),
            onClear: hasCompanyFilters
                ? () =>
                      updateFilters({
                          companyIds: [],
                          titleIds: [],
                          consultants: undefined,
                          fundSizeIds: [],
                          visaStatusIds: [],
                          industryIds: [],
                          sectorIds: [],
                          geoLocationText: [],
                          geoLocationIds: [],
                          startDates: [],
                          processStatusIds: [],
                          processStatusGroupIds: [],
                          type: undefined,
                          internalUserIds: [],
                          createdByUserIds: [],
                          createdAtGte: undefined,
                          createdAtLte: undefined,
                      })
                : undefined,
        },
    ]

    return <FiltersDrawer tabs={tabs} />
}
